import { render, staticRenderFns } from "./LayoutDetails.vue?vue&type=template&id=2fac5186&scoped=true&"
import script from "./LayoutDetails.vue?vue&type=script&lang=js&"
export * from "./LayoutDetails.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDetails.vue?vue&type=style&index=0&id=2fac5186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fac5186",
  null
  
)

export default component.exports